export default __webpack_public_path__ + "static/media/9.b88b9f3c.jpg";